import { Link, useLocation } from 'react-router-dom';

export default function FloatingEnquiryButton() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/admin') || location.pathname.startsWith('/tutor');

  if (isDashboard) return null;

  return (
    <Link
      to="/contact?highlight=true"
      className="fixed right-0 top-1/2 -translate-y-1/2 z-[100] bg-emerald-700 hover:bg-emerald-800 text-white px-1.5 py-4 rounded-l-xl shadow-lg transition-all duration-300 group flex items-center justify-center cursor-pointer"
      style={{
        writingMode: 'vertical-rl',
        textOrientation: 'mixed',
      }}
    >
      <div className="flex flex-col items-center gap-1.5 md:group-hover:-translate-x-0.5 transition-transform">
        <i className="ri-chat-voice-line text-base rotate-90 mb-0.5"></i>
        <span className="font-bold tracking-widest uppercase text-[10px]">Enquire</span>
      </div>
    </Link>
  );
}
